import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=cac6fba4&"
import script from "./Tab1.vue?vue&type=script&lang=js&"
export * from "./Tab1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports